// JavaScript Document
var BookingApp = angular.module('BookingApplication', ['ui.bootstrap','InputNumber','ngRoute','ngAnimate','rzModule','ui.select', 'ngSanitize','slugifier','daterangepicker','switcher']);

BookingApp.constant('dateRangePickerConfig', {
    clearLabel: 'Clear',
    locale: {
        separator: ' - ',
        format: 'MMM DD'
    }
});

BookingApp.directive('loading',[function ()
{
    return {
        restrict: 'A',
        link: function (scope, elm, attrs)
        {
            scope.$on('$routeChangeStart', function ()
            {
                var url = scope.location.path();
                var ar = url.split('/');
                scope.page = ar[1];
                elm.show();
                jQuery(".view-container").addClass('loading');
            });
            scope.$on('$routeChangeSuccess',function(){
                scope.page = "lol";
                elm.hide();
                jQuery(".view-container").removeClass('laoding');
            })
        }
    };
}]);

BookingApp.run(function($rootScope, $location){
    $rootScope.location = $location;
})
BookingApp.config(function($routeProvider, $locationProvider, $provide, $httpProvider) {

    $routeProvider
        .when('/booking', {
            //templateUrl: '/booking/view/main',
            controller: 'BookingController'
        })
        .when('/buses/book/:SessionId/:RouteId', {
            templateUrl: function(RouteParam){ return '/buses/' + RouteParam.SessionId + '/' + RouteParam.RouteId },
            controller: 'BusSeatDetailController',
            resolve:{
                'data' : function(BusService,$route){
                    return BusService.getSeatData($route.current.params);
                }
            }
        })
        .when('/buses/:SourceName/:DestinationName/:DateOfJourney', {
            templateUrl: '/booking/view/bus-listing',
            controller: 'BusesController',
            resolve:{
                'data' : function(BusService,$route){
                    if(BusService.isRequestSet()) BusService.setRequest($route.current.params);
                    return BusService.getData();
                }
            }
        })
        .when('/buses/search/from-:origin-to-:destination-on-:journeyDate-:returnDate-:JourneyType', {
            templateUrl: '/booking/view/bus-listing',
            resolve:{
                'data' : function(BusService,$route){
                    return BusService.getData($route.current.params);
                }
            }
        })
        .when('/buses/search/from-:origin-to-:destination-on-:journeyDate-:JourneyType', {
            templateUrl: '/booking/view/bus-listing',
            resolve:{
                'data' : function(BusService,$route){
                    return BusService.getData($route.current.params);
                }
            }
        })
        .when('/hotels/hotels-in-:destination-:CityCode-:for-:travellers-guest-:rooms-room-on-:startDate-till-:endDate-rooms-data-:roomdata', {
            templateUrl: '/booking/view/hotel-listing',
            resolve:{
                HotelList : function(HotelServices,$route){
                    //console.log($route);
                    return HotelServices.getData($route.current.params)
                }
            },
            //controller: 'HotelListingController'
        })
        .when('/hotels/:seoslug/:trace/:HotelCode/:index', {
            templateUrl: '/booking/view/hotel-detail',
            resolve:{
                data : function(HotelServices,$route){
                    var params = $route.current.params;
                    //HotelServices.setRequest($route.current.params);
                    return HotelServices.getHotelInfo(params.trace,params.HotelCode,params.index);
                }
            },
        })
        .when('/flights/search/from-:origin-to-:destination-on-:journeyDate-:returnDate-:JourneyType-:adult-:child-:infant-:class',{
            templateUrl: '/booking/view/flight-single-listing',
            resolve:{
                data:function (FlightServices,$route) {
                    return FlightServices.getFlights($route.current.params)
                }
            }
        })
        .when('/flights/search/from-:origin-to-:destination-on-:journeyDate-:JourneyType-:adult-:child-:infant-:class',{
            templateUrl: '/booking/view/flight-single-listing',
            resolve:{
                data:function (FlightServices,$route) {
                    return FlightServices.getFlights($route.current.params)
                }
            }
        })
        /*.when('/flights/detail/:traceid/:Index',{
            templateUrl:function(params){
                return '/flights/detail/' + params.traceid + '/' + Index;
            },
            /!*resolve:{
                InBond:function(FlightServices,$route){
                    return FlightServices.getFlightDetail($route.current.params.traceid,$route.current.params.Index)
                },
                OutBond:function(){ return false; },
                hasReturn:function(){ return false;},
            }*!/
        })*/
        .when('/flights/detail/:traceid/:InBound/:OutBound',{
            templateUrl:function(params){
                return '/flights/detail/flight-detail'
            },
            resolve:{
                InBond:function(FlightServices,$route){
                    return FlightServices.getFlightDetail($route.current.params.traceid,$route.current.params.InBound)
                },
                OutBond:function(FlightServices,$route){
                    return FlightServices.getFlightDetail($route.current.params.traceid,$route.current.params.OutBound)
                },
                isinternational:false,
                hasReturn:false,
            }
        })
        .when('/booking/errors', {
            templateUrl: '/booking/view/error',
            controller: 'ErrorController'
        })

    $provide.factory('ErrorInterceptor', function ($q,$location,ErrorServices) {
        return {
            responseError: function(rejection) {
                //alert(rejection);
                //console.log(rejection);
                ErrorServices.setError(rejection.msg)
                $location.path('/errors');
            }
        };
    });

    $httpProvider.interceptors.push('ErrorInterceptor');


    // configure html5 to get links working on jsfiddle
    $locationProvider.html5Mode(true);
});

BookingApp.controller('BookingController',function($scope){
    $scope.$on('$viewContentLoaded', function(){
        search_form_click();
        init_rev_slider();
    });
});


